export default "__VITE_ASSET__uGnpY2Xq__"